export type PatientRosterSortBy =
  | 'clinic'
  | 'patient_first'
  | 'patient_last'
  | 'mrn'
  | 'triage_code'
  | 'disaster_code'
  | 'pdx'
  | 'sdx'
  | 'episode_start_date'
  | 'episode_end_date'
  | 'oasis_date'
  | 'phone'
  | 'date_of_birth'
  | 'age'
  | 'address'
  | 'payer'
  | 'soc_date'
  | 'physician_name'
  | 'physician_npi'
  | 'physician_phone'
  | 'physician_fax'
  | 'assigned_clinician'
  | 'clinician_credentials'
  | 'case_manager'
  | 'clinical_manager'
  | 'scheduled_disciplines';

/**
 * Array of all PatientRosterSortBy values.
 */
export const PATIENTROSTERSORTBY_VALUES: readonly PatientRosterSortBy[] = [
  'clinic',
  'patient_first',
  'patient_last',
  'mrn',
  'triage_code',
  'disaster_code',
  'pdx',
  'sdx',
  'episode_start_date',
  'episode_end_date',
  'oasis_date',
  'phone',
  'date_of_birth',
  'age',
  'address',
  'payer',
  'soc_date',
  'physician_name',
  'physician_npi',
  'physician_phone',
  'physician_fax',
  'assigned_clinician',
  'clinician_credentials',
  'case_manager',
  'clinical_manager',
  'scheduled_disciplines',
] as const;
